/**
 * Servers offered in the Scalar "Try it" client + code samples.
 *
 * The player API (X-Platform-Session) is browser-callable from any origin:
 * the backend CORS policy is `origins '*'`, `headers :any`, no credentials,
 * so the in-page "Test Request" works against staging with no proxy.
 *
 * Operators receive their production base URL during onboarding; the signed
 * server-to-server API (HMAC) is documented but not meant to run from a browser.
 */
export const servers = [
  {
    url: 'https://staging-api.getcardbase.com',
    description: 'Staging — use for live "Try it" requests against the Player API.',
  },
] as const;
